import React from 'react';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { getCohortLabel } from '../constants';
import { ChangeStrategyConfirmModalProps } from '../types';
import Modal from '@cp/src/components/Modal/Modal';

const ChangeStrategyConfirmModal: React.FC<ChangeStrategyConfirmModalProps> = ({
  isOpen,
  targetDpdFilter,
  targetStrategy,
  onConfirm,
  onCancel
}) => {
  const cohortLabel = getCohortLabel(targetDpdFilter, targetStrategy);

  return (
    <Modal
      visible={isOpen}
      onClose={onCancel}
      closeOnOutsideClick
      isHeaderRequired={false}
      showCloseIcon={false}
      contentWrapperClass="!rounded-xl !max-w-[400px]"
      contentClassName="!p-0"
    >
      <div className="px-6 pt-6 pb-4">
        <Typography variant="p3" color="var(--grayscale-2)">
          Are you sure you want to change the customer strategy to{' '}
          <Typography variant="h5" color="var(--grayscale-1)" className="font-bold inline">
            {cohortLabel} ?
          </Typography>
        </Typography>
      </div>

      <div className="px-6 pb-6 flex gap-3">
        <Button variant="secondary" className="flex-1 h-[44px]" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" className="flex-1 h-[44px]" onClick={onConfirm}>
          Confirm
        </Button>
      </div>
    </Modal>
  );
};

export default ChangeStrategyConfirmModal;
